import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle, AlertCircle, Info, AlertTriangle } from 'lucide-react';
import { useToast } from '../../context/ToastContext';

const Toast = () => {
  const { toasts, removeToast } = useToast();

  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return <CheckCircle size={20} className="text-green-500" />;
      case 'error':
        return <AlertCircle size={20} className="text-red-500" />;
      case 'warning':
        return <AlertTriangle size={20} className="text-yellow-500" />;
      default:
        return <Info size={20} className="text-blue-500" />;
    }
  };

  const getStyles = (type) => {
    switch (type) {
      case 'success':
        return 'bg-green-50 border-green-200 text-green-800 shadow-green-500/20';
      case 'error':
        return 'bg-red-50 border-red-200 text-red-800 shadow-red-500/20';
      case 'warning':
        return 'bg-yellow-50 border-yellow-200 text-yellow-800 shadow-yellow-500/20';
      default:
        return 'bg-blue-50 border-blue-200 text-blue-800 shadow-blue-500/20';
    }
  };

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      <AnimatePresence>
        {toasts.map((toast) => (
          <motion.div
            key={toast.id}
            initial={{ 
              opacity: 0, 
              x: 100, 
              scale: 0.8,
              rotateY: 90
            }}
            animate={{ 
              opacity: 1, 
              x: 0, 
              scale: 1,
              rotateY: 0
            }}
            exit={{ 
              opacity: 0, 
              x: 100, 
              scale: 0.8,
              rotateY: -90
            }}
            transition={{ 
              duration: 0.4, 
              type: "spring", 
              stiffness: 200 
            }}
            className={`flex items-center p-4 rounded-2xl border shadow-2xl backdrop-blur-sm max-w-md min-w-[300px] ${getStyles(toast.type)}`}
            whileHover={{ scale: 1.02, y: -2 }}
            layout
          >
            <motion.div 
              className="flex-shrink-0 mr-3"
              animate={{ rotate: [0, 10, -10, 0] }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              {getIcon(toast.type)}
            </motion.div>
            
            <div className="flex-1 min-w-0">
              <motion.p 
                className="text-sm font-semibold"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 }}
              >
                {toast.message}
              </motion.p>
            </div>
            
            <motion.button
              onClick={() => removeToast(toast.id)}
              className="ml-3 flex-shrink-0 text-current opacity-70 hover:opacity-100 transition-opacity p-1 rounded-full hover:bg-white/50"
              whileHover={{ scale: 1.1, rotate: 90 }}
              whileTap={{ scale: 0.9 }}
            >
              <X size={16} />
            </motion.button>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default Toast;
